<script lang="typescript">
    import { push } from "svelte-spa-router";
</script>

<button
    class="absolute top-0 right-0 px-4 mt-10 btn-secondary btn-sm lg:px-8"
    type="button"
    on:click={() => push("/contact-lenses/faqs/")}
>
    Help
</button>
